import { api } from "./client";

export interface Announcement {
  id: string;
  title: string;
  body: string;
  type: "feature" | "maintenance" | "compliance" | "tip";
  ctaUrl: string | null;
  ctaLabel: string | null;
  publishAt: string;
}

export function getAnnouncements() {
  return api.get<{ success: boolean; data: Announcement[] }>("/announcements");
}

export function dismissAnnouncement(id: string) {
  return api.post(`/announcements/${id}/dismiss`);
}
